(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var productIds = [];
    try { productIds = JSON.parse(root.querySelector('[data-belt-product-ids]').textContent); } catch (error) { productIds = []; }
    productIds = productIds.map(String);

    var shippingLimit = Number(root.dataset.shippingLimit) || 0;
    var twoDiscount = Number(root.dataset.twoDiscount) || 0;
    var threeDiscount = Number(root.dataset.threeDiscount) || 0;
    var currency = root.dataset.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var moneyFormat = root.dataset.moneyFormat || '';
    var countNode = root.querySelector('[data-belt-count]');
    var previewNode = root.querySelector('[data-belt-preview]');
    var totalNode = root.querySelector('[data-cart-total]');
    var shippingMessage = root.querySelector('[data-shipping-message]');
    var shippingBar = root.querySelector('[data-shipping-bar]');
    var bundleMessage = root.querySelector('[data-bundle-message]');
    var bundleBar = root.querySelector('[data-bundle-bar]');
    var savingNode = root.querySelector('[data-bundle-saving]');
    var reviewButton = root.querySelector('[data-review-cart]');

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value == null ? '' : value;
      return div.innerHTML;
    }

    function money(cents) {
      if (moneyFormat.indexOf('{{') !== -1) {
        var token = (moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
        var value = Number(cents) || 0;
        var decimals = token.indexOf('no_decimals') !== -1 ? 0 : 2;
        var decimalMark = token.indexOf('comma_separator') !== -1 ? ',' : '.';
        var thousandsMark = token.indexOf('comma_separator') !== -1 ? '.' : ',';
        var parts = (value / 100).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
        return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, parts[0] + (decimals ? decimalMark + parts[1] : ''));
      }
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100); }
      catch (error) { return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency; }
    }

    function replaceTokens(text, values) {
      return Object.keys(values).reduce(function (output, key) {
        return output.replace(new RegExp('\\[' + key + '\\]', 'g'), values[key]);
      }, text || '');
    }

    function beltState(cart) {
      var quantity = 0;
      var subtotal = 0;
      cart.items.forEach(function (item) {
        if (productIds.indexOf(String(item.product_id)) !== -1) {
          quantity += item.quantity;
          subtotal += item.original_line_price;
        }
      });
      return { quantity: quantity, subtotal: subtotal };
    }

    function render(cart) {
      var belts = beltState(cart);
      var discountRate = belts.quantity >= 3 ? threeDiscount : (belts.quantity >= 2 ? twoDiscount : 0);
      var simulatedSaving = cart.total_discount > 0 ? cart.total_discount : Math.round(belts.subtotal * discountRate / 100);
      var displayedTotal = Math.max(0, cart.total_price - (cart.total_discount > 0 ? 0 : simulatedSaving));
      var latest = cart.items[0];

      countNode.textContent = belts.quantity;
      totalNode.textContent = money(displayedTotal);
      reviewButton.disabled = cart.item_count === 0;
      reviewButton.textContent = cart.item_count ? root.dataset.reviewButton + ' · ' + money(displayedTotal) : root.dataset.emptyButton;

      if (!latest) {
        previewNode.innerHTML = '<div class="belt-builder__preview-empty">' + escapeHtml(root.dataset.emptyPreview) + '</div>';
      } else {
        var image = latest.featured_image && latest.featured_image.url ? latest.featured_image.url : latest.image;
        previewNode.innerHTML = (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(latest.product_title) + '">' : '') +
          '<div class="belt-builder__preview-meta"><span class="belt-builder__preview-name">' + escapeHtml(latest.product_title) + '</span>' +
          '<span class="belt-builder__preview-price">' + money(latest.final_price) + '</span>' +
          '<span class="belt-builder__preview-count">' + belts.quantity + ' ' + escapeHtml(belts.quantity === 1 ? root.dataset.beltSingular : root.dataset.beltPlural) + '</span></div>';
      }

      var remaining = Math.max(0, shippingLimit - displayedTotal);
      var shippingPercent = shippingLimit > 0 ? Math.min(100, displayedTotal / shippingLimit * 100) : 100;
      if (remaining > 0) {
        shippingMessage.innerHTML = replaceTokens(escapeHtml(root.dataset.shippingLocked), { amount: '<strong>' + money(remaining) + '</strong>' });
      } else {
        shippingMessage.innerHTML = '<strong>' + escapeHtml(root.dataset.shippingUnlocked) + '</strong>';
      }
      shippingBar.style.width = shippingPercent + '%';

      var message;
      var bundlePercent;
      if (belts.quantity === 0) {
        message = replaceTokens(root.dataset.emptyProgress, { two_discount: twoDiscount, three_discount: threeDiscount });
        bundlePercent = 0;
      } else if (belts.quantity < 2) {
        message = replaceTokens(root.dataset.buyTwoProgress, { count: 2 - belts.quantity, discount: twoDiscount });
        bundlePercent = belts.quantity / 2 * 50;
      } else if (belts.quantity < 3) {
        message = replaceTokens(root.dataset.buyThreeProgress, { count: 3 - belts.quantity, discount: threeDiscount });
        bundlePercent = 75;
      } else {
        message = replaceTokens(root.dataset.maxProgress, { discount: threeDiscount });
        bundlePercent = 100;
      }
      bundleMessage.innerHTML = escapeHtml(message).replace(/(\d+%)/g, '<strong>$1</strong>').replace(/Add (\d+)/, 'Add <strong>$1</strong>');
      bundleBar.style.width = bundlePercent + '%';

      if (simulatedSaving > 0) {
        savingNode.hidden = false;
        savingNode.innerHTML = '<span>Belt bundle discount (−' + discountRate + '%)</span><span>−' + money(simulatedSaving) + '</span>';
      } else {
        savingNode.hidden = true;
        savingNode.innerHTML = '';
      }
    }

    function getCart() {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
    }

    function add(button) {
      button.classList.add('is-loading');
      button.disabled = true;
      var body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (response) { if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add product'); }); return response.json(); })
        .then(function (data) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
          return getCart();
        })
        .then(render)
        .catch(function (error) { window.alert(error.message); })
        .finally(function () { button.classList.remove('is-loading'); button.disabled = false; });
    }

    root.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-belt-add]');
      if (addButton) { event.preventDefault(); add(addButton); return; }
      if (event.target.closest('[data-review-cart]')) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = window.Shopify.routes.root + 'cart';
      }
    });

    document.addEventListener('cart:updated', function () { getCart().then(render); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { getCart().then(render); });
    }
    document.addEventListener('shopify:section:load', function (event) { if (event.target.contains(root)) getCart().then(render); });
    getCart().then(render);
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-belt-builder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
